import { LastInteractedStore } from '../machine/LastInteractedStore.machine.types';

/**
 * Small utility function to get delivery details from the last interacted store.
 */
export function getLastInteractedDeliveryDetails(lastInteractedStore: LastInteractedStore) {
  const { addressId, deliveryFee, vendor, vendorRestaurantId } = lastInteractedStore ?? {};

  if (!addressId || !deliveryFee || !vendor || !vendorRestaurantId) return;

  return {
    tip: 0,
    addressId,
    deliveryFee,
    vendor,
    vendorRestaurantId,
  };
}
